import React, { useCallback, useState } from 'react';
import { Box } from '@mui/material';

import { ComponentPreview } from './ComponentPreview';

const DEFAULT_WIDTH = 115;
const DEFAULT_HEIGHT = 52;

/**
 * A `<ComponentPreview>` that renders a `<Paper />` container and automatically sizes the preview canvas to fit that
 *   container. As this relies on external CSS to determine the size of the `<Paper />` it is not suitable for use in
 *   all situations. It also relies on the container having the appropriate size when it first mounts, and does not
 *   handle resizing over time.
 */

export function AutoSizingComponentPreview(props: { componentDesignGuid: string }) {
  const padding = 8;

  const [width, setWidth] = useState(DEFAULT_WIDTH);
  const [height, setHeight] = useState(DEFAULT_HEIGHT);

  const setSize = useCallback(
    (el: HTMLDivElement | null) => {
      if (el == null) return;

      const rect = el.getBoundingClientRect();
      setWidth(rect.width - padding * 2);
      setHeight(rect.height - padding * 2);
    },
    [padding],
  );

  return (
    <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }} ref={setSize}>
      <ComponentPreview componentDesignGuid={props.componentDesignGuid} maxWidth={width} maxHeight={height} />
    </Box>
  );
}
